import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },

  //Projects Menu
  {
    path: '/projects',
    name: 'Projects',
    component: () => import( '../views/Projects.vue')
  },


  //TODO APP Project
  {
    path: '/projects/todo-app',
    name: 'TodoApp',
    component: () => import( '../views/Projects/Todo-app.vue')
  },
  {
    path: '/projects/todo-app/add-task',
    name: 'AddTask',
    component: () => import( '../components/Project-components/Todo-app/AddTask.vue')
  },
  {
    path: '/projects/todo-app/edit-task/:task_slug',
    name: 'EditTask',
    component: () => import( '../components/Project-components/Todo-app/EditTask.vue')
  },

  //Typing-speed project
  {
    path: '/projects/typing-speed',
    name: 'TypingSpeed',
    component: () => import( '../views/Projects/Typing-speed.vue')
  },

  //Constitution
  {
    path: '/projects/constitution',
    name: 'Constitution',
    component: () => import( '../views/Projects/Constitution.vue')
  },

  //Dashboard
  {
    path: '/projects/dashboard',
    name: 'Dashboard-proj',
    component: () => import( '../views/Projects/Dashboard.vue')
  },

  //Data Visualization
  {
    path: '/projects/data-viz',
    name: 'Data-viz',
    component: () => import( '../views/Projects/Data-viz.vue')
  },

  //Quiz
  {
    path: '/projects/quiz',
    name: 'Quiz',
    component: () => import( '../views/Projects/Quiz.vue')
  },
  {
    path: '/projects/quiz/session/:amount&:category&:difficulty&:type',
    name: 'Quiz-ses',
    component: () => import( '../components/Project-components/Quiz/Quiz-ses.vue'),
    props: true
  },

  //App-store
  {
    path: '/projects/app-store',
    name: 'App-store',
    component: () => import( '../views/Projects/App-store.vue')
  },
  {
    path: '/projects/app-store/:app_name',
    name: 'Display',
    component: () => import( '../components/Project-components/App-store/Display.vue')
  },

  
]

const router = new VueRouter({
  routes
})

export default router
